import React from 'react';
import { Link } from 'react-router-dom'

import item from '../../assets/fake-data/item';


const Technology = (props) => {

const data = props.data;
  return (
    <section className="tf-section technology" id='technology'>
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="block-text center">
                        <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Web Technologies</h5>
                        <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">React | Typescript | Javascript | Python | APIs</h3>
                    </div>
                </div>
            </div>
            <div className="row mt-53">
                <div className="col-xl-6 col-md-12">
                    <div className="row">
                        {
                            data.map((data,index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="icon-box bg-2" data-aos="fade-up">
                                        <div className="icon">
                                            <img src={data.icon} alt={`${data.title} icon`} />
                                        </div>
                                        <div className="content">
                                            <Link to="#" className="h5">
                                                {data.title}
                                            </Link>
                                            <p className="fs-16">{data.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                        
                    </div>
                </div>
                <div className="col-xl-6 col-md-12">
                    <div className="group-image">
                        <img src={item.technology} alt="Web development technology stack illustration" />
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
}

export default Technology;